/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/13/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl';
import {Grid} from "@scuf/common";
import {fetchFaultsWithoutPagination} from "../api/Faults";
import {CURRENT_FAULT_STATES, FAULT_SORT, FAULT_STATES} from "../faults/common/FaultsConst";
import {ROLES} from "../security/SecurityConst"
import Loader from "../common/Loader";
import FaultsFilter from "../faults/list/FaultsFilter";
import DashboardHeader from "./DashboardHeader";
import FaultsListExpandable from "./FaultsListExpandable";
import FaultsListWithLink from "./FaultsListWithLink"
import AssetChart from '../common/AssetChart'
import {fetchFleets} from "../api/Fleets";
import {fetchUsers} from "../api/Users";
import {FLEETS_SORT} from "../fleets/FleetsConst";
import FleetChart from "../common/FleetChart";
import UsersAssignmentChart from "../common/UsersAssignmentChart";
import {Routes} from "../utils/Routes";
import CorruptionModal from "../common/CorruptionModal";
import {checkCorruptionOfDatabases} from "../api/AppConfigs";

class FleetManagerDashboard extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            search: '',
            sort: FAULT_SORT.MODIFIED,
            assignedFaults: [],
            assignedFaultsUnfiltered: null,
            unassignedFaults: [],
            faultStatesCount: null,
            fleets: null,
            fleetUsers: null,
            databaseCorruptionResult: null,
            closeCorruptionModal: false,
        }

        this.searchChanged = this.searchChanged.bind(this)
        this.sortChanged = this.sortChanged.bind(this)
    }

    componentDidMount() {
        this.fetchFaultsData()

        fetchFleets('', FLEETS_SORT.NAME, undefined, 1).then((data) => {
            this.setState({fleets: data})
        })

        fetchUsers('', 'userName', 'ASC', null, null, [ROLES.WORKER, ROLES.ADVANCED_WORKER], 1).then((data) => {
            this.setState({fleetUsers: data})
        })
        this.checkCorruptionOfDatabase();
    }

    checkCorruptionOfDatabase() {
        checkCorruptionOfDatabases().then((data) => {
            if (data != null && data.user != null && data.logString != null) {
                this.setState({databaseCorruptionResult: data, closeCorruptionModal: true})
            }
        })
    }

    fetchFaultsData() {
        this.setState({loading: true})

        fetchFaultsWithoutPagination([FAULT_STATES.NEW, FAULT_STATES.IN_PROGRESS, FAULT_STATES.ON_HOLD, FAULT_STATES.VERIFICATION, FAULT_STATES.NEW_ALERT],
            this.state.search, this.state.sort, null, -1).then((pageableResponse) => {
            this.setState({unassignedFaults: pageableResponse.results})
        })

        fetchFaultsWithoutPagination([FAULT_STATES.NEW, FAULT_STATES.IN_PROGRESS, FAULT_STATES.ON_HOLD, FAULT_STATES.VERIFICATION,
                FAULT_STATES.CLOSED_RESOLVED, FAULT_STATES.NEW_ALERT, FAULT_STATES.CLOSED_DUE_TO_LDI_IMPORT,
                FAULT_STATES.CLOSED_DUE_TO_INACTIVITY],
            this.state.search, this.state.sort, null, null).then((pageableResponse) => {
            const data = pageableResponse.results
            this.setState({assignedFaults: data})

            if (!this.state.assignedFaultsUnfiltered) {
                this.setState({assignedFaultsUnfiltered: data})
            }

            //compute fault states count only once
            if (!this.state.faultStatesCount) {
                const faultStatesCount = {}
                data.forEach(f => {
                    // Fault with name starting 'Alert#' and with NEW state will be on UI shown with state 'NEW_ALERT' (this state doesn't really exist in DB)
                    const state = f.faultConditionState === FAULT_STATES.NEW && f.name.startsWith('Alert#') ? FAULT_STATES.NEW_ALERT : f.faultConditionState;
                    if (!faultStatesCount[state]) {
                        faultStatesCount[state] = 0
                    }
                    faultStatesCount[state] += 1
                })
                this.setState({faultStatesCount: faultStatesCount})
            }
            this.setState({loading: false})
        })
    }

    searchChanged(search) {
        this.setState({search: search}, this.fetchFaultsData)
    }

    sortChanged(sort) {
        if (sort !== this.state.sort) {
            this.setState({sort: sort}, this.fetchFaultsData)
        }
    }

    getFaultsChart() {
        if (!this.state.faultStatesCount || !this.state.fleets) {
            return null
        }

        let count = 0
        CURRENT_FAULT_STATES.forEach(s => {
            count += this.state.faultStatesCount[s] || 0
        })

        const faults = {
            faultsCount: count,
            faultStatesCount: this.state.faultStatesCount,
        }
        return <AssetChart asset={faults} height={200} onClick={() => this.goToFaults()}/>
    }

    getAssetsChart() {
        if (!this.state.faultStatesCount || !this.state.fleets) {
            return null
        }

        let count = 0
        let mergedAssetFaultStatesCount = []
        this.state.fleets.forEach(f => {
            count += f.assetCount
            mergedAssetFaultStatesCount =   mergedAssetFaultStatesCount.concat(f.assetsFaultStatesCount)
        })

        const fleets = {
            assetCount: count,
            assetsFaultStatesCount: mergedAssetFaultStatesCount,
        }

        return <FleetChart fleet={fleets} height={200} onClick={() => this.goToFleets()}/>
    }

    goToFleets() {
        const {history} = this.props
        history.push(Routes.FLEETS)
    }

    goToFaults() {
        const {history} = this.props
        history.push(Routes.FAULTS)
    }

    render() {
        const {intl, history} = this.props

        const inProgressFaultsCards = this.state.assignedFaults.filter(
            f => f.faultConditionState === FAULT_STATES.IN_PROGRESS || f.faultConditionState === FAULT_STATES.ON_HOLD || f.faultConditionState === FAULT_STATES.VERIFICATION)
        const newFaultsCards = this.state.assignedFaults.filter(f => f.faultConditionState === FAULT_STATES.NEW)
        const closedFaults = this.state.assignedFaults.filter(f => f.faultConditionState === FAULT_STATES.CLOSED_RESOLVED);

        return (
            <div>
                <CorruptionModal
                    open={this.state.closeCorruptionModal}
                    onClose={() => {this.setState({closeCorruptionModal: false})}}
                    databaseCorruptionResult={this.state.databaseCorruptionResult}
                />
                <Loader loading={this.state.loading}/>
                <DashboardHeader bottomChildren={
                    <Grid.Row>
                        <Grid.Column width={6} sWidth={12}>
                            <Grid.Column width={6} sWidth={6} xsWidth={12}>
                                {this.getFaultsChart()}
                            </Grid.Column>
                            <Grid.Column width={6} sWidth={6} xsWidth={12}>
                                {this.getAssetsChart()}
                            </Grid.Column>
                        </Grid.Column>
                        <Grid.Column width={6} sWidth={12}>
                            <div className="users-chart">
                                <UsersAssignmentChart assignedFaults={this.state.assignedFaultsUnfiltered} users={this.state.fleetUsers}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>}>
                </DashboardHeader>
                <FaultsFilter sort={this.state.sort} sortOptions={FAULT_SORT} sortChanged={this.sortChanged}
                              searchChanged={this.searchChanged} />
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <FaultsListExpandable title={intl.formatMessage({id: "dashboard.faults.new"})} faults={newFaultsCards}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <FaultsListExpandable title={intl.formatMessage({id: "dashboard.faults.inProgress"})} faults={inProgressFaultsCards}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <FaultsListWithLink title={intl.formatMessage({id: "dashboard.faults.recentHistory"})}
                                          faults={closedFaults}
                                          onClick={closedFaults.length > 0 ? () => history.push('/faults?tab=history') : null}
                                            linkText={intl.formatMessage({id: "dashboard.faults.recentHistory.link"})}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12} className="unassigned">
                            <FaultsListExpandable title={intl.formatMessage({id: "dashboard.faults.unassigned"})} faults={this.state.unassignedFaults}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(FleetManagerDashboard)))